import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Avatar, Breadcrumb, Layout, Menu, message } from "antd";
import { MdDashboard, MdOutlineSupervisedUserCircle } from "react-icons/md";
import {
  BellOutlined,
  BuildOutlined,
  HomeOutlined,
  LogoutOutlined,
  MessageOutlined,
  RestTwoTone,
  UserOutlined,
  WalletFilled,
  WalletTwoTone,
} from "@ant-design/icons";
import { TbCategoryPlus } from "react-icons/tb";
import { VscRequestChanges, VscSymbolProperty } from "react-icons/vsc";
import { GrServices } from "react-icons/gr";
import { Header } from "antd/es/layout/layout";
import { BiBuildingHouse, BiListCheck, BiTransfer, BiWallet } from "react-icons/bi";
import { useSelector } from "react-redux";

const { Sider, Content } = Layout;

const BasicLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("");
  const parm = useLocation();
  const trimRoute = parm.pathname.split("/")
  const wallet = useSelector((state) => state.B2B.walletBal);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      window.innerWidth <= 600 ? setCollapsed(true) : setCollapsed(false);
    };
    window.addEventListener("resize", handleResize);
    const stored = localStorage.getItem("selected");
    if (stored) {
      setSelectedMenu(stored);
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("selected", selectedMenu);
  }, [selectedMenu]);

  function getlogout() {
    localStorage.clear();
    navigate("/vendor");
    message.success("Vendor Logged Out Successfully");
  }

  const layoutStyle = {
    borderRadius: 8,
    overflow: "hidden",
  };

  // Add titles to each menu item
  const menuItems = [
    {
      key: "1",
      icon: <MdDashboard />,
      label: "Dashboard",
      title: "Dashboard",
      onClick: () => {
        setSelectedMenu("1");
        navigate("/dashboard");
      },
    },

    {
      key: "5",
      icon: <VscRequestChanges />,
      label: "Order List",
      title: "Order List",
      onClick: () => {
        setSelectedMenu("5");
        navigate("/orderlist");
      },
    },
    {
      key: "6",
      icon: <BiBuildingHouse />,
      label: "Restro List",
      title: "Restro List",
      onClick: () => {
        setSelectedMenu("6");
        navigate("/restroList");
      },
    },
    {
      key: "11",
      icon: <BiListCheck />,
      label: "Role Management",
      title: "Role Management",
      onClick: () => {
        setSelectedMenu("11");
        navigate("/permissionList");
      },
    },
    // {
    //   key: "13",
    //   icon: <BiListCheck />,
    //   label: "Brand Management",
    //   title: "Brand Management",
    //   onClick: () => {
    //     setSelectedMenu("13");
    //     navigate("/brandList");
    //   },
    // },
    {
      key: "7",
      icon: <BiTransfer />,
      label: "Transaction List",
      title: "Transaction List",
      onClick: () => {
        setSelectedMenu("7");
        navigate("/transactionList");
      },
    },
    // {
    //   key: "7",
    //   icon: <VscSymbolProperty />,
    //   label: "Properties",
    //   title: "Properties",
    //   onClick: () => {
    //     setSelectedMenu("7");
    //     navigate("/propertiesDetails");
    //   },
    // },
    {
      key: "8",
      icon: <LogoutOutlined />,
      label: "Sign Out",
      title: "Sign Out",
      onClick: () => {
        setSelectedMenu("8");
        getlogout();
      },
    },
  ];

  const currentMenuItem = menuItems.find((item) => item.key === selectedMenu);

  // const finer = (fileSystem) => {
  //  let Count = 0

  //   for (let file in fileSystem) {
  //     if(file == "files"){
  //       fileSystem[file].map((item)=>(Count+=item))
  //     }
  //     console.log("==============>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",fileSystem[file]);
  //     if(Array.isArray(fileSystem[file]) && fileSystem[file].every((item)=> typeof item == "object" ) ){
  //       finer(fileSystem[file] )
  //     }
  //     else{
  //       fileSystem.totalScore = ""
  //     }
  //   }


  //   return fileSystem

  // }

  // const fileSystem = {
  //   name: "root",
  //   files: [1200, 3000], // Sizes in bytes
  //   subdirectories: [
  //     {
  //       name: "subdir1",
  //       files: [800],
  //       subdirectories: [
  //         {
  //           name: "subsubdir1",
  //           files: [400, 200],
  //           subdirectories: [],
  //         },
  //       ],
  //     },
  //     {
  //       name: "subdir2",
  //       files: [1000, 500],
  //       subdirectories: [],
  //     },
  //   ],
  // };




  // console.log(finer(fileSystem))


  return (
    <Layout style={layoutStyle} className="min-h-screen sidebar bg-[#edf2f9]">
      <Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          width: "100%",
          top: "0",
          zIndex: "1",
        }}
      >
        <div>
          <p className="font-bold text-lg font-poppins">
            Restaurant Management
          </p>
        </div>
        <div className="flex justify-center items-center gap-3" >
          <Link to={"/profile"} >
            <UserOutlined

              style={{ fontSize: "20px", cursor: "pointer", marginLeft: "15px" }}
            />
          </Link>


          <LogoutOutlined
            onClick={() => getlogout()}
            style={{ fontSize: "20px", cursor: "pointer", marginLeft: "15px" }}
          />
          <div className=" items-center p-0 px-3 h-11  flex justify-center flex-row   text-center bg-black rounded-md ">
            <WalletFilled
              style={{ fontSize: "20px", cursor: "pointer" }}
            />

            <span >:{" "}   ₹{wallet || JSON.parse(localStorage.getItem("wallet"))}</span>
          </div>
        </div>

      </Header>
      <Layout>
        <Sider
          style={{ position: "fixed" }}
          width="15%"
          className="h-[100vh] z-10 text-center top-16"
          collapsible
          // width={290}
          collapsed={collapsed}
          onCollapse={() => setCollapsed(!collapsed)}
        >
          {/* <div className="demo-logo-vertical d-flex justify-content-center m-2 ">
            <div>
              <Avatar shape="square" size={64} icon={<UserOutlined />} />
            </div>
            {!collapsed ? (
              <div className="w-full mt-2 p-2 h-16 gap-4">
                <p className="font-bold">Restaurant manager</p>
              </div>
            ) : (
              <div className="w-5 mt-9 px-2  grid">

                <p className=" text-xs">Restaurant manager</p>
              </div>
            )}

            {!collapsed ? (
              <div className="w-full mt-2 p-2   justify-center text-center">
                <Link to={"/profile"} >
                  <UserOutlined className="m-3" />{" "}
                </Link>

                {/* <MessageOutlined className="m-3" />{" "} */}
          {/* <LogoutOutlined onClick={() => getlogout()} className="m-3" /> */}
          {/* </div>
            ) : (
              <div className="w-5 m-2 p-2  justify-center text-center">
                <UserOutlined className="m-2" />{" "}
                {/* <MessageOutlined className="m-2" />{" "} */}
          <LogoutOutlined onClick={() => getlogout()} className="m-2" />
          {/* </div> */}
          {/* )} */}
          <div className="border-b-2"></div>
          {/* </div> */}
          <Menu
            mode="inline"
            className="text-base pb-24 font-inter"
            selectedKeys={[selectedMenu]}
          >
            {menuItems.map((item) => (
              <Menu.Item key={item.key} icon={item.icon} onClick={item.onClick}>
                {item.label}
              </Menu.Item>
            ))}
          </Menu>
        </Sider>
        {collapsed ?
          <Content
            className="min-h-screen mt-16 ml-24 relative p-4"
          >
            {currentMenuItem?.title === "Dashboard" ? (
              <div></div>
            ) : (
              <div className="w-full h-auto bg-white p-3 shadow-sm shadow-gray-300">
                <Breadcrumb
                  items={[
                    {
                      title: (
                        <div className="flex">
                          <p>
                            <MdDashboard className="font-bold text-2xl text-rgbaprimary8" />
                          </p>
                          <p className="text-base text-rgbaprimary8">
                            {" "}Dashboard
                          </p>
                        </div>
                      ),
                    },
                    {
                      title: (
                        currentMenuItem?.title === "Vendors" ? (
                          <p onClick={() => navigate("/vendorsDetails")} className="cursor-pointer text-base">
                            {currentMenuItem?.title}
                          </p>
                        ) : (
                          <p className="cursor-pointer text-base">
                            {currentMenuItem?.title}
                          </p>
                        )
                      ),
                    },
                    ...(trimRoute[1] === "restrolist"
                      ? [{
                        title: (
                          <p className="text-base">RestroList</p>
                        ),
                      }]
                      : []),
                  ]}
                />

              </div>
            )}

            {children}
          </Content>
          :
          <Content
            className="min-h-screen relative p-4"
            style={{
              margin: "64px 0 0 15%",
            }}
          >
            {currentMenuItem?.title === "Dashboard" ? (
              <div></div>
            ) : (
              <div className="w-full h-auto bg-white p-3 shadow-sm shadow-gray-300">
                <Breadcrumb
                  items={[
                    {
                      title: (
                        <div className="flex">
                          <p>
                            <MdDashboard className="font-bold text-2xl text-rgbaprimary8" />
                          </p>
                          <p className="text-base text-rgbaprimary8">
                            {" "}
                            Dashboard
                          </p>
                        </div>
                      ),
                    },
                    {
                      title: (
                        currentMenuItem?.title == "Vendors" ?
                          <p onClick={() => navigate("/vendorsDetails")} className=" cursor-pointer text-base">{currentMenuItem?.title}</p>
                          :
                          <p className=" cursor-pointer text-base">{currentMenuItem?.title}</p>
                      ),
                    },
                    trimRoute[1] == "restrolist" &&
                    {

                      title: (
                        <p className="text-base">RestroList</p>
                      ),
                    },
                  ]}
                />
              </div>
            )}

            {children}
          </Content>
        }
      </Layout>
    </Layout>
  );
};

export default BasicLayout;
